import _get from 'lodash/get';
import cx from 'classnames';
import { IconFilter } from '@/shared/ui/Icons';
import Popover from '@/shared/ui/Popover';
import Box from '@/shared/ui/Box';
import WorkersFiltersContent from './WorkersFiltersContent';
import type { WorkersFiltersProps } from './WorkersFilters';
import { hasActiveFilters } from './utils/hasActiveFilters';
import s from './WorkersFilter.module.scss';

const WorkersFiltersDesktop = (props: WorkersFiltersProps) => {
  const { className, values = {} } = props;
  const isActive = hasActiveFilters(values);
  return (
    <>
      <Popover modal={false} triggerComponent={
        <button className={cx(className, s.btn, {
          [s.isActive]: isActive,
        })}>
          <IconFilter color="text-inherit"/>
        </button>
      }>
        <Box className={s.boxContainer}>
          <WorkersFiltersContent {...props}/>
        </Box>
      </Popover>
    </>
  );
}

export default WorkersFiltersDesktop;
